import {
  ORDER_HISTORY_DATE_FILTER,
  ORDER_HISTORY_SEARCH_FILTER,
  SET_LOGOUT_AUTH
} from '../actions/Index';

const initState = {
  search: ''
};
const dateInitState = {
  fromDate: '',
  toDate: ''
};

export function OrderHistorySearchReducer(state = initState, action: any): any {
  const {type, payload} = action;
  switch (type) {
    case ORDER_HISTORY_SEARCH_FILTER:
      return {
        search: payload.item
      };
    case SET_LOGOUT_AUTH:
      return {
        ...initState
      };
    default:
      return state;
  }
}

export function OrderHistoryDateReducer(
  state = dateInitState,
  action: any
): any {
  const {type, payload} = action;
  switch (type) {
    case ORDER_HISTORY_DATE_FILTER:
      return {
        fromDate: payload.fromDate,
        toDate: payload.toDate
      };
    case SET_LOGOUT_AUTH:
      return {
        ...initState
      };
    default:
      return state;
  }
}
